import React, {Component, PropTypes} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {
    selectPage,
    saveData,
    fetchFormsIfNeeded,
    fetchConversionTable,
    updateData,
    showModal,
    surveyStateSendToCustomer,
    surveyStateInProgress,
    surveyStateSubmitted,
    surveyStateReviewed,
    saveItems,
    fetchFormData
} from '../actions';
import Page from '../components/Page';
import {Nav, NavItem, Modal} from 'react-bootstrap';
import {browserHistory} from 'react-router';
import { ToastContainer, toast } from 'react-toastify';

class SelectedPage extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleStartSurvey = this.handleStartSurvey.bind(this);
        this.handlePageDataChange = this.handlePageDataChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.state = {key: 1, isChanged: false , formInitData: null};
    }

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(fetchFormsIfNeeded());
        dispatch(fetchConversionTable());
        // this.props.dispatch (fetchFormData(formId));
    }

    handleChange(nextPage) {
        if (this.state.isChanged) {
          toast( () => (<div style={{background: "#fff" , color: "#000"}}>Save or cancel changes on the page to proceed.</div>));
          return;
        }
        const currentPage = this.props.selectedPage;
        const { form, formId } = this.props;
        // this.props.dispatch (fetchFormData(formId));
        this.props.dispatch(selectPage(nextPage, form));
        if (nextPage-1 < form.pages.length && nextPage !== 0){ 
          const formInitData = _.clone (this.props.form.pages[nextPage-1].formData);
          this.setState({formInitData});
        } 
        this.setState({"isChanged": false});
        this.setState({"key": Date.now()});
    }

    handleStartSurvey(nextPage) {
        const { form, formId } = this.props;
        this.props.dispatch(surveyStateInProgress(formId));
        this.props.dispatch(selectPage(nextPage, form));
        
        const formInitData = _.clone (this.props.form.pages[nextPage-1].formData);
        this.setState({formInitData});
        this.setState({"isChanged": false});
        this.setState({"key": Date.now()});
    }

    handleSendToCustomer() {
        const { formId } = this.props;
        this.props.dispatch(surveyStateSendToCustomer(formId));
    }

    handleCloseSurvey() {
        const { form, formId } = this.props;
        this.props.dispatch(surveyStateReviewed(form, formId));
        this.setState({"isChanged": false});
    }

    handlePageDataChange(data) {
      // save changed data locally, it is saved to backend when user presses save
      this.props.dispatch(updateData(this.props.selectedPage, data.formData));
      this.setState({"isChanged": true});
    }

    makeListFromFormData(formData){
      let returnList = [];
      Object.keys (formData).forEach (element => {
        // if this is "folder" structure, check it's childrens.
        if (!formData[element].hasOwnProperty('value') && !formData[element].hasOwnProperty('comment')) {
          returnList = returnList.concat (this.makeListFromFormData(formData[element]));
        } else
        {
          let parameter = {
            key: element,
            value: undefined,
            unit: undefined,
            comment: undefined,
          }
          if (typeof formData[element].value === "number" || typeof formData[element].value === "string" || typeof formData[element].value === "boolean"){
            parameter.value = formData[element].value;
          } else {
            if (typeof formData[element].value === "object"){
              if (formData[element].value.hasOwnProperty('value')) {
                parameter.value = formData[element].value.value;
              }
              if (formData[element].value.hasOwnProperty('unit')) {
                parameter.unit = formData[element].value.unit;
              }
            }
          }
          if (formData[element].comment)
            parameter.comment = formData[element].comment;
          returnList.push (parameter);
        }
      });
      return returnList;
    }

    compareData (newData, oldData){
      let returnObject = {};
      newData.forEach (element => {
        if (element.value === undefined && element.unit === undefined && element.comment === undefined) {
          // send empty ?
        } else {
          let oldElement = _.find(oldData, {key:element.key});
          if (!_.isEqual(oldElement, element)) {
            returnObject[element.key] = {
              value: element.value,
              unit: element.unit,
              comment: element.comment,
            } 
          }
        }
      });
      return returnObject;
    }
    saveData(page) {
      const { formId } = this.props;
      let newData = _.orderBy(this.makeListFromFormData(this.props.form.pages[page].formData), 'key', 'asc');
      let oldData = _.orderBy(this.makeListFromFormData(this.state.formInitData), 'key', 'asc');
      const saveObject= this.compareData(newData, oldData);
      this.props.dispatch(saveItems(saveObject, formId));
      toast( () => (<div style={{background: "#fff" , color: "#000"}}>Page saved.</div>));
      this.setState({"key": Date.now()});
    }

    handleSave(page) {
      this.saveData(page-1);
      // save new data to initial data as it is saved.
      const formInitData = _.clone (this.props.form.pages[page-1].formData);
      this.setState({formInitData});
      this.setState({"isChanged": false});
    }

    handleCancel(page) {
      this.props.dispatch(updateData(this.props.selectedPage, this.state.formInitData));
      this.setState({"isChanged": false});
      this.setState({"key": Date.now()});
    }

    submitSurveyAnswers() {
        const { form, formId } = this.props;
        this.props.dispatch(surveyStateSubmitted(form, formId))
        this.props.dispatch(showModal(true));
        this.setState({"isChanged": false});
    }


    hideModal() {
        this.props.dispatch(showModal(false));
        browserHistory.push('/');
    }

    renderInfoForInternalUser() {
      const {allowedActions, user, form, isFetching} = this.props;

      return (
        <div className="row col-xs-12">
            <div className="alert alert-success" role="alert">
                <h3>ADMIN Access for VALMET Internal Users</h3>
                {allowedActions.includes('SEND_TO_CUSTOMER') ?
                    <div><p>You can update and review pre-filled survey before sending it to customer.</p>
                        <button className="btn btn-comments" onClick={() => this.handleSendToCustomer()}>Send to
                            customer
                        </button>
                    </div> : ''}
                {allowedActions.includes('MARK_REVIEWED') ?
                    <div><p>You can review this survey that has been completed by customer.</p>
                        <button disabled={isFetching} className="btn btn-comments" onClick={() => this.handleCloseSurvey()}>Accept and
                            close survey
                        </button>
                    </div> : ''
                }
                {form.formCSVUrl != undefined && form.formCSVUrl != "" ? <small><a href={form.formCSVUrl}>Download saved survey</a></small> : ""}
            </div>
        </div>
      )
    }

    // renderInfoForExternalUserOld() {
    //     const {user, form, isFetching} = this.props;
    //
    //     return (
    //         <div className="row col-xs-12">
    //             <div className="alert alert-success" role="alert">
    //                 <p><b>Instructions</b></p>
    //                 <small>
    //                 <p>To save the data you have filled in press the save-button in every page or if you want to cancel the data you have just filled in press the cancel-button.</p>
    //                 <p>If you want to leave and continue later, remember also then to save the data you have already filled in by using the save-button first and then leave.</p>
    //                 <p>You have two ways to change page: you can select page number from top of form or use buttons on bottom.</p>
    //                 <p>For date use format YYYY-MM-DD</p>
    //                 <p>Use dot instead of comma when adding figures.</p>
    //                 <p>After submit (you can find that button on the last page) you can't anymore see or change the values. After submit button is pressed you can download csv-file that contains information you have filled into survey. You can find download link from list of your machines after you sign in to survey again.</p>
    //                 <p><b>Note! Do not refresh browser or information that you have just updated on current page will be lost!</b></p>
    //                 </small>
    //                 {form.formUserGuideUrl != undefined && form.formUserGuideUrl != "" && form.isFetchinGuide != true ?
    //                   <a title="Flag drawn by User:SKopp, redrawn by User:Denelson83 and User:Zscout370  Recode by cs:User:-xfi- (code), User:Shizhao (colors) [Public domain], via Wikimedia Commons" target="_blank" href={form.formUserGuideUrl}><img width="32" alt="Flag of the People&#039;s Republic of China" src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_the_People%27s_Republic_of_China.svg/32px-Flag_of_the_People%27s_Republic_of_China.svg.png"/> Chinese Instructions</a>: ""}
    //             </div>
    //         </div>
    //     )
    // }

    renderInfoForExternalUser() {
        const {user, form, isFetching} = this.props;

        return (
            <div className="row col-xs-12">
                <div className="alert alert-success" role="alert">

                    {form.formUserGuideUrl != undefined && form.formUserGuideUrl != "" && form.isFetchinGuide != true ?
                      <a title="Flag drawn by User:SKopp, redrawn by User:Denelson83 and User:Zscout370  Recode by cs:User:-xfi- (code), User:Shizhao (colors) [Public domain], via Wikimedia Commons" target="_blank" href={form.formUserGuideUrl}><img width="32" alt="Flag of the People&#039;s Republic of China" src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_the_People%27s_Republic_of_China.svg/32px-Flag_of_the_People%27s_Republic_of_China.svg.png"/> Chinese Instructions</a>: ""}
                </div>
            </div>
        )
    }

    render() {
        const {allowedActions, formVisibility, formState, selectedPage, form, isFetching, modalReducer, user, conversionTable} = this.props;

        return (
            <div className="survey-root">
                {user != undefined && allowedActions != undefined && user.survey_role === 'INTERNAL' ?
                    this.renderInfoForInternalUser() : this.renderInfoForExternalUser()}
                <h1 className="survey-title">{form.formName}</h1>

                <Nav style={{display: isFetching ? "none" : "block"}} className="survey-pagination" bsStyle="pills"
                     activeKey={selectedPage} onSelect={this.handleChange}>
                    <NavItem eventKey={0} key="0" className="intro">Introduction</NavItem>

          {form.pages.map((page,pageIndex) =>
              <NavItem className={pageHasErrors(form.formErrors, pageIndex+1) && "error"} disabled={selectedPage==0?true:false} eventKey={pageIndex+1} key={pageIndex+1}>{pageIndex+1}</NavItem>
          )}

                    <NavItem disabled={selectedPage == 0 ? true : false} eventKey={form.pages.length + 1} key={form.pages.length + 1}
                             className="complete">Complete</NavItem>
                </Nav>


                {isFetching &&
                <p>Loading survey...</p>
                }

                {!isFetching && form.pages.length === 0 &&
                <p>Survey empty</p>
                }

                {(form.pages.length > 0) && (selectedPage !== 0) && (selectedPage !== form.pages.length + 1) &&
                <div style={{display: isFetching ? "none" : "block"}}>
                    <Page key = {this.state.key}
                          page={form.pages[selectedPage - 1]}
                          onChange={this.handlePageDataChange}
                          onSectionChange={this.handleChange}
                          onSave={this.handleSave}
                          onCancel={this.handleCancel}
                          isChanged={this.state.isChanged}
                          selectedPage={selectedPage}
                          conversionTable={conversionTable}
                          totalPages={form.pages.length}/>
                </div>
                }

                {(form.pages.length > 0) && (selectedPage == 0) && (!isFetching) &&
                <div>
                    <h2>Dear Customer,</h2>
                    <p>Our best wishes for this year.</p>

                      <p>We would much appreciate it if you could fill in this survey questionnaire of production and energy data and send it back to us. Thank you in advance!</p>


                    {allowedActions.includes('SEND_TO_CUSTOMER')
                        && formVisibility.includes(user.survey_role) ?
                        <button className="btn btn-comments" onClick={() => this.handleChange(1)}>Open
                            survey</button> : ''}
                    {allowedActions.includes('MARK_REVIEWED')  && formVisibility.includes(user.survey_role) ?
                        <button className="btn btn-comments" onClick={() => this.handleChange(1)}>Start
                            review</button> : ''}
                    {allowedActions.includes('START_ANSWERING')
                        && formVisibility.includes(user.survey_role) ?
                        <button className="btn btn-comments" onClick={() => this.handleStartSurvey(1)}>Start
                            survey</button> : ''}
                    {allowedActions.includes('SUBMIT')
                        && formVisibility.includes(user.survey_role) ?
                        <button className="btn btn-comments" onClick={() => this.handleChange(1)}>Continue
                            survey</button> : ''}

                </div>
                }


        {(form.pages.length > 0) && (selectedPage === form.pages.length+1)
        && formVisibility.includes(user.survey_role) &&
        <div>
          {form.hasErrors &&
          <div>
            <h2>Review your answers</h2>
            <p>Please check your answers in page{errorsOnPages(form.formErrors).length > 1 && "s"}: <strong>{errorsOnPages(form.formErrors).join(",")}</strong></p>
          </div>}

          {!form.hasErrors &&
          <div>
            <h2>Survey completed</h2>
            <p>Submit your answers</p>
          </div>}

            <button disabled={form.hasErrors} className="btn btn-comments" onClick={() => this.submitSurveyAnswers()}>Submit</button>
        </div>
        }

                <Modal show={modalReducer} onHide={this.close}>
                    <Modal.Body>
                        <h2 style={{textAlign: 'center'}}>Thank you for answering the survey</h2>
                        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                        </svg>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-comments" onClick={() => this.hideModal()}>Close</button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        )
    }
}


function errorsOnPages(formErrors){
  var pages = formErrors.map(function(e, i){
    if(e.length > 0) {
      return i+1;
    }
  });
  return pages.filter(function(e){return e !== undefined});
}

function pageHasErrors(formErrors, pageNumber){
  const error = errorsOnPages(formErrors).find((e) => {
    return e == pageNumber
  })

  if (error == pageNumber) {
    return true;
  }
  return false;
}

SelectedPage.propTypes = {
    selectedPage: PropTypes.number.isRequired,
    form: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
}

function mapStateToProps(state, ownProps) {

    const {selectedPage, form, forms, user, modalReducer} = state
    const isFetching = form.isFetching;
    let formVisibility, allowedActions = null;
    let formState = "";
    state.forms.formsList.forEach(element => {
      if (element.formId === ownProps.formId) {
        allowedActions = element.allowedActions;
        formVisibility = element.formVisibility;
        formState = element.formState;
      }
    });
    return {
        selectedPage,
        form,
        formState,
        isFetching,
        user: user.user,
        conversionTable: forms.conversionTable,
        modalReducer,
        allowedActions,
        formVisibility,
    }
}

export default connect(mapStateToProps)(SelectedPage)


// WEBPACK FOOTER //
// ./src/containers/SelectedPage.js